import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm, useFieldArray, useWatch, } from "react-hook-form";
import { getOnlyToken, ConfirmationAlert } from "../utils/commonFunctions";
import Loader from "../Components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

export default function CreateWorkFlow() {
  const [currentStep, setCurrentStep] = useState(1);
  const [workflowId, setWorkflowId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timeGroupsList, setTimeGroupsList] = useState([]);
  const [ivrList, setIvrList] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [companies,setCompanies]= useState([])
  const [successMessage,setSuccessMessage]= useState("")
  const [successModal,setSuccessModal]= useState(false)
  const navigate = useNavigate()
  const location = useLocation();

  const { company_id,editMode,workID } = location.state || {};

  console.log('Company ID:', company_id);
  console.log('Edit Mode:', editMode);
console.log('Work ID:', workID);

  const {
    register,
    control,
    handleSubmit,
    trigger,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      timeGroups: [
        {
          title: "",
          startHour: "",
          startMinute: "",
          endHour: "",
          endMinute: "",
          weekStart: "",
          weekEnd: "",
          monthDayStart: "",
          monthDayEnd: "",
          monthStart: "",
          monthEnd: "",
          isSaved: false,
        },
      ],
    },
  });



  const { fields, append, remove, update, replace } = useFieldArray({
    control,
    name: "timeGroups",
  });


  const [phoneNumbers, setPhoneNumbers] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      await fetchPhoneNumbers();
      if (workID && editMode) {
        setWorkflowId(workID);
        await fetchWorkflowData();
      }
    };
    loadData();
  }, [])

  useEffect(()=>{
    fetchCompanies()
  },[])

    const fetchCompanies = async ()=>{
    try {
    const token = getOnlyToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get('api/agents/folder/create/',config)
      if(res.status === 200){
        setCompanies(res.data.folders)
      }
    } catch (error) {
      console.error('Failed to fetch agents for folder', error);
      setCompanies([]);
    }
  }


  const fetchPhoneNumbers = async () => {
    const token = getOnlyToken();
    const config = { headers: { Authorization: `Bearer ${token}` } };
    try {
      const res = await axios.get(`/ivr/phone-numbers/`, config);

      if (res.status === 200) {
        setPhoneNumbers(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching phone numbers:", error);
    }

  }

  const fetchWorkflowData = async (id = workID) => {
    setLoading(true);
    const token = getOnlyToken();
    const config = { headers: { Authorization: `Bearer ${token}` } };
    try {
      const res = await axios.get(`/ivr/workflow-config/${id}/`, config);
      if (res.status === 200) {
        const data = res.data;
        setWorkflowId(id);
        reset({
          workflowName: data.name,
          description: data.description,
          workflowType: data.workflow_type.charAt(0).toUpperCase() + data.workflow_type.slice(1),
          company: data.company,
          phoneNumber: data.phone_number ? String(data.phone_number) : "",
          did: data.did ? String(data.did) : "",
          callRecording: String(data.call_recording_enabled),
        });
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
    setLoading(false);
  }


  const fetchTimeGroups = async () => {
    setLoading(true);
    const token = getOnlyToken();
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const resp = await axios.get(`/ivr/time-group/?work_flow=${workflowId}`, config);
    if (resp.data && resp.data.length > 0) {
      setTimeGroupsList(resp.data);
      const transformed = resp.data.map(tg => ({
        timeGroupId: tg.id,
        title: tg.name,
        startHour: tg.start_at.split(':')[0],
        startMinute: tg.start_at.split(':')[1],
        endHour: tg.end_at.split(':')[0],
        endMinute: tg.end_at.split(':')[1],
        weekStart: tg.week_start_day.charAt(0).toUpperCase() + tg.week_start_day.slice(1),
        weekEnd: tg.week_end_day.charAt(0).toUpperCase() + tg.week_end_day.slice(1),
        monthDayStart: tg.month_start_day,
        monthDayEnd: tg.month_end_day,
        monthStart: tg.start_month.charAt(0).toUpperCase() + tg.start_month.slice(1),
        monthEnd: tg.end_month.charAt(0).toUpperCase() + tg.end_month.slice(1),
        isSaved: true
      }));
      replace(transformed);
    }
    setLoading(false);
  };

  const fetchTimeConditionData = async () => {
    setLoading(true);
    const token = getOnlyToken();
    const config = { headers: { Authorization: `Bearer ${token}` } };
    try {
      const res = await axios.get(`/ivr/time-condition-config/?work_flow=${workflowId}`, config);
      if (res.status === 200 && res.data.length > 0) {
        const tcData = res.data[0];
        const timeConditions = timeGroupsList.map(tg => {
          const matchingCondition = tcData.time_conditions?.find(tc => tc.time_group === tg.id);
          return {
            ivrMatch: matchingCondition ? String(matchingCondition.destination) : ""
          };
        });
        reset({
          ...getValues(),
          timeConditionName: tcData.time_condition_name,
          timeZone: tcData.time_zone,
          designationNonMatches: String(tcData.destination_non_matching),
          timeConditions
        });
      }
    } catch (error) {
      console.error("Error fetching time condition data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (workflowId && currentStep === 2) {
      fetchTimeGroups();
    }
    if (workflowId && currentStep === 3 && editMode) {
      fetchTimeConditionData();
    }
  }, [workflowId, currentStep]);


  const steps = [
    { id: 1, label: "Profile", icon: "bi-person-badge" },
    { id: 2, label: "Time Group", icon: "bi-clock-history" },
    { id: 3, label: "Time Condition", icon: "bi-diagram-3" },
  ];
  const nextStep = async () => {
    if (currentStep === 1) {
      const valid = await trigger(["workflowName", "description", "workflowType", "did", "callRecording"]);
      if (!valid) return;

      const values = getValues();

      const payload = {
        workflow_type: values.workflowType?.toLowerCase() || "inbound",
        name: values.workflowName,
        description: values.description || "",
        // company: values.company,
        call_recording_enabled: values.callRecording === "true",
        did: values.did || null,
      };

      const token = getOnlyToken();
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      try {
        console.log('workflowId before API call:', workflowId);
        const resp = workflowId
          ? await axios.put(`/ivr/workflow-config/${workflowId}/`, payload, config)
          : await axios.post(`/ivr/workflow-config/`, payload, config);

        if (resp.status === 200 || resp.status === 201) {
          setWorkflowId(resp.data.id);
          setCurrentStep(2);
           setSuccessModal(true);
        setSuccessMessage("workflow Created Successfully");
        }
      } catch (error) {
        setErrorMessage(error.response?.data?.did || error.message || "Failed to save workflow");
        setErrorModal(true);
        return;
      }
    }


    if (currentStep === 2) {
      const allSaved = fields.every((f) => f.isSaved);
      if (!allSaved) {
        alert("Please save all Time Groups before proceeding");
        return;
      }

      await fetchTimeGroups();

      const token = getOnlyToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };

      const ivrResp = await axios.get(`/ivr/ivr-config/dropdown/`, config);

      if (ivrResp.status === 200) {
        setIvrList(ivrResp.data);
        setSuccessMessage("Time  Group Updated Successfully");
         setSuccessModal(true);

      }

      setCurrentStep(3);
      
      if (editMode && workflowId) {
        await fetchTimeConditionData();
      }
    }
  };


  const prevStep = async () => {
    const newStep = currentStep - 1;
    setCurrentStep(newStep);

    
    
    if (workflowId && editMode) {
      if (newStep === 1) {
        await fetchWorkflowData(workflowId);
      } else if (newStep === 2) {
        await fetchTimeGroups();
      }
    }
  };

  const saveTimeGroup = async (index) => {
    const valid = await trigger(`timeGroups.${index}`);
    if (!valid) return;

    setLoading(true);

    const tg = getValues(`timeGroups.${index}`);

    const payload = {
      work_flow: workflowId,
      name: tg.title,
      start_at: `${tg.startHour}:${tg.startMinute}:00`,
      end_at: `${tg.endHour}:${tg.endMinute}:00`,
      week_start_day: tg.weekStart.toLowerCase(),
      week_end_day: tg.weekEnd.toLowerCase(),
      month_start_day: Number(tg.monthDayStart),
      month_end_day: Number(tg.monthDayEnd),
      start_month: tg.monthStart.toLowerCase(),
      end_month: tg.monthEnd.toLowerCase(),
    };

    const token = getOnlyToken();
    const config = { headers: { Authorization: `Bearer ${token}` } };

    if (tg.timeGroupId) {
      await axios.put(`/ivr/time-group/${tg.timeGroupId}/`, payload, config);
    } else {
      await axios.post(`/ivr/time-group/`, payload, config);
    }

    await fetchTimeGroups();
  };


  const deleteTimeGroup = async (index) => {
    const tg = fields[index];
    ConfirmationAlert(
      `Are you sure you want to delete the time group "${tg.title}"?`,
      "Delete",
      async () => {
        if (tg.timeGroupId) {
          setLoading(true);
          const token = getOnlyToken();
          const config = { headers: { Authorization: `Bearer ${token}` } };
          await axios.delete(`/ivr/time-group/${tg.timeGroupId}/`, config);
          await fetchTimeGroups();
        } else {
          remove(index);
        }
      }
    );
  };

  const cancelEdit = async (index) => {
    const tg = fields[index];
    if (tg.timeGroupId) {
      await fetchTimeGroups();
    } else {
      remove(index);
    }
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const timeConditionsData = timeGroupsList.map((tg, index) => ({
        time_group: tg.id,
        destination: Number(data.timeConditions[index].ivrMatch)
      }));

      const payload = {
        time_condition_name: data.timeConditionName,
        work_flow: workflowId,
        time_zone: data.timeZone,
        destination_non_matching: Number(data.designationNonMatches),
        time_conditions_data: timeConditionsData
      };

      const token = getOnlyToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };
      if(editMode){
        const res = await axios.put(`ivr/time-condition-config/${workflowId}/`, payload, config);
        if (res.status === 200 || res.status === 201) {
          // alert("Workflow Updated Successfully");
          navigate('/workflow',{state : {company_id:company_id}} )
        }
      }
        const res = await axios.post('/ivr/time-condition-config/', payload, config);

      if (res.status === 201) {
        setSuccessModal(true);
        setSuccessMessage("Time  Conditions Updated Successfully");
        
        reset();
     setTimeout(()=>{
         navigate('/workflow')
     },1500)
      }
      setCurrentStep(1);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage(error.response?.data?.message || error.message || "An error occurred while creating workflow");
      setErrorModal(true);
    }
  };
  const weekOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const monthOrder = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const isTimeValid = (startH, startM, endH, endM) => {
    if (!startH || !startM || !endH || !endM) return true;
    return `${endH}${endM}` >= `${startH}${startM}`;
  };

  const isRangeValid = (start, end, list) => {
    if (!start || !end) return true;
    return list.indexOf(end) >= list.indexOf(start);
  };

  const timeGroupsWatch = useWatch({
    control,
    name: "timeGroups",
  });

  return (
    <>

      {loading ?
        <div
          className="full-page-loader-overlay"
        >
          <Loader />
        </div>
        :
        <div className="container-fluid py-4 ">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="fw-bold text-success mb-4">{editMode  ? "Edit Workflow" : "Create Workflow"}</h2>
            <button
              onClick={() => navigate('/workflow')}
              className="btn btn-primary btn-sm d-flex fs-6 align-items-center gap-1 px-3"
            >
              <i className="bi bi-arrow-left"></i>
              Back
            </button>
          </div>
          {/* ================= STEPPER ================= */}
          <div className="card border-secondary mb-4">
            <div className="card-body px-4">
              <div className="d-flex align-items-center w-100">

                {steps.map((step, index) => (
                  <div
                    key={step.id}
                    className="d-flex align-items-center"
                    style={{ flex: index === steps.length - 1 ? "0 0 auto" : "1 1 0" }}
                  >
                    {/* Step circle */}
                    <div
                      className={`rounded-circle d-flex align-items-center justify-content-center
              ${currentStep > step.id ? "bg-success" : "border border-secondary"}
            `}
                      style={{ width: 40, height: 40, cursor: "pointer", backgroundColor: currentStep === step.id ? '#035c8bff' : '' }}
                      onClick={() => step.id < currentStep && setCurrentStep(step.id)}
                    >
                      {currentStep > step.id ? (
                        <i className="bi bi-check-lg text-white"></i>
                      ) : (
                        <i
                          className={`bi ${step.icon} ${currentStep === step.id
                            ? "text-white"
                            : "text-secondary"
                            }`}
                        ></i>
                      )}
                    </div>

                    {/* Label */}
                    <div
                      className={`ms-2 fw-semibold text-nowrap ${currentStep === step.id
                        ? "text-white"
                        : "text-secondary"
                        }`}
                    >
                      {step.label}
                    </div>

                    {/* Connector line */}
                    {index < steps.length - 1 && (
                      <div
                        className={`mx-3 border-top border-2 flex-grow-1 ${currentStep > step.id
                          ? "border-success"
                          : "border-secondary"
                          }`}
                      />
                    )}
                  </div>
                ))}

              </div>
            </div>
          </div>


          {/* ================= FORM ================= */}
          <div className="card  border-secondary">
            <div className="card-body p-4 ">

              {/* -------- STEP 1 -------- */}
              {currentStep === 1 && (
                <>
                  <h5 className="mb-3">Profile</h5>

                  {/* ROW 1 */}
                  <div className="row g-3 ">
                    {/* Workflow Name */}
                    <div className="col-md-4 ">
                      <label className="form-label">Workflow Name *</label>
                      <input
                        className="form-control text-white border-secondary"
                        placeholder=' Please enter Workflow name'
                        {...register("workflowName", {
                          required: "Workflow name is required",
                        })}
                      />
                      <small className="text-danger">
                        {errors.workflowName?.message}
                      </small>
                    </div>

                    {/* Description */}
                    <div className="col-md-4">
                      <label className="form-label">Description *</label>
                      <input
                       placeholder=' Please enter Description here'
                        className="form-control text-white border-secondary"
                        {...register("description", {
                          required: "Description is required",
                        })}
                      />
                      <small className="text-danger">
                        {errors.description?.message}
                      </small>
                    </div>

                    {/* Workflow Type */}
                    <div className="col-md-4">
                      <label className="form-label">Workflow Type *</label>
                      <select
                        className="form-select text-white border-secondary"
                        {...register("workflowType", {
                          required: "Workflow type is required",
                        })}
                      >
                        <option value="">Select type</option>
                        <option value="Inbound">Inbound</option>
                        <option value="Outbound">Outbound</option>
                      </select>
                      <small className="text-danger">
                        {errors.workflowType?.message}
                      </small>
                    </div>
                  </div>

                  {/* ROW 2 */}
                  <div className="row g-3 mt-1">
                    {/* Phone Number */}
                    {/* <div className="col-md-4">
                      <label className="form-label">Phone Number *</label>
                      <select
                        className="form-select text-white border-secondary"
                        {...register("did", {
                          required: "Phone number is required",
                          setValueAs: (v) => (v ? Number(v) : null),
                        })}
                      >
                        <option value="">Select phone number</option>
                        {phoneNumbers?.map((item) => (
                          <option key={item.line_id} value={item.line_id}>
                            {item.line} ({item.line_type})
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {errors.did?.message}
                      </small>
                    </div> */}

                        {/* <div className="col-md-3">
                <label className="form-label fw-semibold">
                  Company *
                </label>
                <select
                  className={`form-select ${errors.company ? 'is-invalid' : ''}`}
                  {...register("company", { required: "Company is required" })}
                >
                  <option value="">-- Select Company --</option>
                  {companies.map((comp) => (
                    <option key={comp.id} value={comp.id}>
                      {comp.folder_data?.company_name || comp.folder_name}
                    </option>
                  ))}
                </select>
                {errors.company && <div className="invalid-feedback d-block">{errors.company.message}</div>}
              </div> */}

                    {/* Call Recording */}
                    <div className="col-md-3">
                      <label className="form-label d-block">Call Recording *</label>
                      <div className="d-flex align-items-center gap-4 mt-2">
                        <div className="form-check">
                          <input
                            type="radio"
                            value="true"
                            id="on"
                            className="form-check-input"
                            {...register("callRecording", {
                              required: "Call recording selection is required",
                            })}
                          />
                          <label htmlFor="on" className="form-check-label">
                            ON
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            type="radio"
                            value="false"
                            id="off"
                            className="form-check-input"
                            {...register("callRecording", {
                              required: "Call recording selection is required",
                            })}
                          />
                          <label htmlFor="off" className="form-check-label">
                            OFF
                          </label>
                        </div>
                      </div>

                      <small className="text-danger d-block mt-1">
                        {errors.callRecording?.message}
                      </small>
                    </div>
                  </div>
                </>


              )}

              
              {currentStep === 2 && (

                <>
                  <h5 className="mb-3">Time Groups</h5>

                  {fields.map((item, index) => {
                    const tg = timeGroupsWatch?.[index] || {};

                    return (
                      <div
                        key={item.id}
                        className="border border-secondary rounded p-3 mb-3"
                      >
                        {/* ===== TITLE ===== */}
                        <div className="mb-3 col-md-4">
                          <label className="form-label">Time Group Title *</label>
                          <input
                            disabled={item.isSaved}
                            className="form-control form-control-sm border-secondary text-white"
                            {...register(`timeGroups.${index}.title`, {
                              required: "Title is required",
                            })}
                          />
                          <small className="text-danger">
                            {errors?.timeGroups?.[index]?.title?.message}
                          </small>
                        </div>

                        {/* ===== TIME ===== */}
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <label className="form-label">Time to Start *</label>
                            <div className="d-flex gap-2">
                              <select
                                disabled={item.isSaved}
                                className="form-select form-select-sm border-secondary text-white"
                                {...register(`timeGroups.${index}.startHour`, { required: "Required" })}
                              >
                                <option value="">HH</option>
                                {Array.from({ length: 24 }, (_, i) => (
                                  <option key={i} value={String(i).padStart(2, "0")}>
                                    {String(i).padStart(2, "0")}
                                  </option>
                                ))}
                              </select>

                              <select
                                disabled={item.isSaved}
                                className="form-select form-select-sm border-secondary text-white"
                                {...register(`timeGroups.${index}.startMinute`, { required: "Required" })}
                              >
                                <option value="">MM</option>
                                {["00", "15", "30", "45"].map(m => (
                                  <option key={m} value={m}>{m}</option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Time to Finish *</label>
                            <div className="d-flex gap-2">
                              <select
                                disabled={item.isSaved}
                                className="form-select form-select-sm border-secondary text-white"
                                {...register(`timeGroups.${index}.endHour`, { required: "Required" })}
                              >
                                <option value="">HH</option>
                                {Array.from({ length: 24 }, (_, i) => (
                                  <option key={i} value={String(i).padStart(2, "0")}>
                                    {String(i).padStart(2, "0")}
                                  </option>
                                ))}
                              </select>

                              <select
                                disabled={item.isSaved}
                                className="form-select form-select-sm border-secondary text-white"
                                {...register(`timeGroups.${index}.endMinute`, {
                                  required: "Required",
                                  validate: () =>
                                    isTimeValid(
                                      tg.startHour,
                                      tg.startMinute,
                                      tg.endHour,
                                      tg.endMinute
                                    ) || "Finish time cannot be before start time",
                                })}
                              >
                                <option value="">MM</option>
                                {["00", "15", "30", "45"].map(m => (
                                  <option key={m} value={m}>{m}</option>
                                ))}
                              </select>
                            </div>
                            <small className="text-danger">
                              {errors?.timeGroups?.[index]?.endMinute?.message}
                            </small>
                          </div>
                        </div>

                        {/* ===== WEEK ===== */}
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <label className="form-label">Week Day Start *</label>
                            <select
                              disabled={item.isSaved}
                              className="form-select form-select-sm border-secondary text-white"
                              {...register(`timeGroups.${index}.weekStart`, { required: "Required" })}
                            >
                              <option value="">-- Select --</option>
                              {weekOrder.map(d => (
                                <option key={d} value={d}>{d}</option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Week Day Finish *</label>
                            <select
                              disabled={item.isSaved}
                              className="form-select form-select-sm border-secondary text-white"
                              {...register(`timeGroups.${index}.weekEnd`, {
                                required: "Required",
                                validate: v =>
                                  isRangeValid(tg.weekStart, v, weekOrder) ||
                                  "Week finish cannot be before start",
                              })}
                            >
                              <option value="">-- Select --</option>
                              {weekOrder.map(d => (
                                <option key={d} value={d}>{d}</option>
                              ))}
                            </select>
                            <small className="text-danger">
                              {errors?.timeGroups?.[index]?.weekEnd?.message}
                            </small>
                          </div>
                        </div>

                        {/* ===== MONTH DAY ===== */}
                        <div className="row g-3 mb-2">
                          <div className="col-md-6">
                            <label className="form-label">Month Day Start *</label>
                            <input
                              type="number"
                              disabled={item.isSaved}
                              className="form-control form-control-sm border-secondary text-white"
                              {...register(`timeGroups.${index}.monthDayStart`, {
                                required: "Month day start is required",
                                min: {
                                  value: 1,
                                  message: "Day must be between 1 and 31",
                                },
                                max: {
                                  value: 31,
                                  message: "Day must be between 1 and 31",
                                },
                              })}
                            />
                            <small className="text-danger">
                              {errors?.timeGroups?.[index]?.monthDayStart?.message}
                            </small>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Month Day End *</label>
                            <input
                              type="number"
                              disabled={item.isSaved}
                              className="form-control form-control-sm border-secondary text-white"
                              {...register(`timeGroups.${index}.monthDayEnd`, {
                                required: "Month day end is required",
                                min: {
                                  value: 1,
                                  message: "Day must be between 1 and 31",
                                },
                                max: {
                                  value: 31,
                                  message: "Day must be between 1 and 31",
                                },
                                validate: (value) => {
                                  const start = Number(tg.monthDayStart);
                                  const end = Number(value);

                                  if (!start || !end) return true;

                                  return end >= start || "Month day end cannot be before start";
                                },
                              })}
                            />
                            <small className="text-danger">
                              {errors?.timeGroups?.[index]?.monthDayEnd?.message}
                            </small>
                          </div>
                        </div>


                        {/* ===== MONTH ===== */}
                        <div className="row g-3">
                          <div className="col-md-6">
                            <label className="form-label">Month Start *</label>
                            <select
                              disabled={item.isSaved}
                              className="form-select form-select-sm border-secondary text-white"
                              {...register(`timeGroups.${index}.monthStart`, { required: "Required" })}
                            >
                              <option value="">-- Select --</option>
                              {monthOrder.map(m => (
                                <option key={m} value={m}>{m}</option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label">Month Finish *</label>
                            <select
                              disabled={item.isSaved}
                              className="form-select form-select-sm border-secondary text-white"
                              {...register(`timeGroups.${index}.monthEnd`, {
                                required: "Required",
                                validate: v =>
                                  isRangeValid(tg.monthStart, v, monthOrder) ||
                                  "Month finish cannot be before start",
                              })}
                            >
                              <option value="">-- Select --</option>
                              {monthOrder.map(m => (
                                <option key={m} value={m}>{m}</option>
                              ))}
                            </select>
                            <small className="text-danger">
                              {errors?.timeGroups?.[index]?.monthEnd?.message}
                            </small>
                          </div>
                        </div>

                        {/* ===== ACTIONS ===== */}
                        {!item.isSaved && (
                          <div className="d-flex justify-content-end gap-2 mt-3">
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => cancelEdit(index)}
                            >
                              Cancel
                            </button>

                            <button
                              type="button"
                              className="btn btn-success btn-sm"
                              onClick={() => saveTimeGroup(index, item)}
                            >
                              Save
                            </button>
                          </div>
                        )}

                        {item.isSaved && (
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <div className="text-success fw-semibold">
                              <i className="bi bi-check-circle me-1"></i>
                              Time Group Saved
                            </div>
                            <div className="d-flex gap-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => update(index, { ...item, isSaved: false })}
                                title="Edit"
                              >
                                <i className="bi bi-pencil"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => deleteTimeGroup(index)}
                                title="Delete"
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  <button
                    type="button"
                    className="btn btn-outline-white border-white fw-semibold"
                    onClick={() =>
                      append({
                        title: "",
                        startHour: "",
                        startMinute: "",
                        endHour: "",
                        endMinute: "",
                        weekStart: "",
                        weekEnd: "",
                        monthDayStart: "",
                        monthDayEnd: "",
                        monthStart: "",
                        monthEnd: "",
                        isSaved: false,
                      })
                    }
                  >
                    <i className="bi bi-plus-lg me-1"></i>
                    ADD TIME GROUP
                  </button>
                </>
              )}




              {/* -------- STEP 3 -------- */}
              {currentStep === 3 && (
                <>
                  <h5 className="mb-3">Time Condition</h5>

                  <div className="mb-4">
                    <label className="form-label">Time Condition Name *</label>
                    <input
                      type="text"
                      className="form-control text-white border-secondary"
                      {...register("timeConditionName", {
                        required: "Time condition name is required",
                      })}
                    />
                    <small className="text-danger">
                      {errors.timeConditionName?.message}
                    </small>
                  </div>

                  {timeGroupsList && timeGroupsList.length > 0 && timeGroupsList.map((tg, index) => (
                    <div key={tg.id} className="border border-secondary rounded p-3 mb-3">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label">Time Group</label>
                          <input
                            type="text"
                            className="form-control text-white border-secondary"
                            value={tg.name}
                            disabled
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Destination Matches (IVR) *</label>
                          <select
                            className="form-select text-white border-secondary"
                            {...register(`timeConditions.${index}.ivrMatch`, {
                              required: "IVR is required",
                            })}
                          >
                            <option value="" >-- Select IVR --</option>
                            {ivrList && ivrList.length > 0 && ivrList.map(ivr => (
                              <option className="text-white" key={ivr.id} value={ivr.id}>{ivr.ivr_name}</option>
                            ))}
                          </select>
                          <small className="text-danger">
                            {errors?.timeConditions?.[index]?.ivrMatch?.message}
                          </small>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="row g-3 mt-3">
                    <div className="col-md-6">
                      <label className="form-label">Time Zone *</label>
                      <select
                        className="form-select text-white border-secondary"
                        {...register("timeZone", { required: "Time zone is required" })}
                      >
                        <option value="">-- Select Time Zone --</option>
                        <option value="IST">IST</option>
                        <option value="EST">EST</option>
                        <option value="GMT">GMT</option>
                        <option value="PST">PST</option>
                        <option value="CET">CET</option>
                        <option value="UST">UST</option>
                        <option value="UTC">UTC</option>

                      </select>
                      <small className="text-danger">{errors.timeZone?.message}</small>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Designation NON Matches *</label>
                      <select
                        className="form-select text-white border-secondary"
                        {...register("designationNonMatches", {
                          required: "Required",
                        })}
                      >
                        <option value="">-- Select --</option>
                        {ivrList && ivrList.length > 0 && ivrList.map(ivr => (
                          <option key={ivr.id} value={ivr.id}>{ivr.ivr_name}</option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {errors.designationNonMatches?.message}
                      </small>
                    </div>
                  </div>
                </>
              )}


              {/* -------- ACTIONS -------- */}
              <div className="d-flex justify-content-between mt-4 pt-3 ">
                {currentStep > 1 && (
                  <button className="btn btn-outline-secondary" onClick={prevStep}>
                    Back
                  </button>
                )}

                {currentStep < 3 ? (
                  <button className="btn btn-primary ms-auto" onClick={nextStep}>
                    Save & Next
                  </button>
                ) : (
                  <button
                    className="btn btn-success ms-auto"
                    onClick={handleSubmit(onSubmit)}
                  >
                    {editMode  ? "Update Workflow" : "Create Workflow"}                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

      }

     <Modal
  show={errorModal}
  onHide={() => setErrorModal(false)}
  centered
  backdrop="static"
>
  <Modal.Body className="text-center p-4">
    {/* Icon */}
    <div className="mb-3">
      <div
        className="rounded-circle d-inline-flex align-items-center justify-content-center border border-danger "
        style={{ width: 56, height: 56 }}
      >
        <i className="bi bi-exclamation-lg fs-3 text-danger"></i>
      </div>
    </div>

    {/* Title */}
    <h5 className="fw-semibold mb-2">Something went wrong</h5>

    {/* Message */}
    <p className="text-muted mb-4">
      {errorMessage || "We couldn’t complete the action. Please try again."}
    </p>

    {/* Action */}
    <button
      className="btn btn-outline-danger px-4"
      onClick={() => setErrorModal(false)}
    >
      Okay
    </button>
  </Modal.Body>
</Modal>



  
      {/* SUCCESS MODAL */}
      <Modal
        show={successModal}
        onHide={() => setSuccessModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 shadow-lg rounded-4"
      >
        <Modal.Body className="p-4 text-center">
          {/* Icon */}
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 80,
              height: 80,
              background: "linear-gradient(135deg, #28a745, #20c997)",
            }}
          >
            <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
          </div>

          {/* Title */}
          <h5 className="fw-bold mb-2">Success</h5>

          {/* Message */}
          <p className="text-muted mb-4">{successMessage}</p>

          {/* Action */}
          <Button
            variant="success"
            className="px-4 fw-semibold rounded-pill"
            onClick={() => setSuccessModal(false)}
          >
            Done
          </Button>
        </Modal.Body>
      </Modal>


    </>
  );

}
